import React from 'react'

import { ICourse } from './types'
import { Title } from '@/components/title'
import MDContent from '../MDContent'

interface IProps {
  course: ICourse
}

const Course = (props: IProps) => {
  const { course } = props

  return (
    <div className='container justify-between px-4 mx-auto max-w-screen-xl antialiased'>
      <div className='dark:border-jacarta-600 dark:bg-jacarta-700 border-jacarta-100 rounded-[1.25rem] border bg-white p-[5%] lg:flex lg:flex-col'>
        <Title title={course.metadata.title} />
        <MDContent content={course.content} />
      </div>
    </div>
  )
}

export default Course
